module.exports = __webpack_public_path__ + "img/image-center.aa3885bd.png";